import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { invalidateCustomer, invalidateCustomersServiceStationDetails } from '../../../api/customer'
import {
  invalidateServiceStationCache,
  useCreateServiceStation,
  useUpdateServiceStation,
} from '../../../api/service-station'
import { AppFormProps } from '../../../components/FormCore'
import { ShowDialogProps } from '../../../show-dialog'
import ServiceStationFrom from '../../serviceStations/ServiceStationForm'

interface ServiceStationDialogProps extends ShowDialogProps, AppFormProps {
  title: string
  customerId: EntityId
}

export const ServiceStationDialog: FC<ServiceStationDialogProps> = ({
  title,
  customerId,
  initialValues,
  pop,
  ...rest
}) => {
  const { mutateAsync: createServiceStation } = useCreateServiceStation(customerId)
  const { mutateAsync: updateServiceStation } = useUpdateServiceStation(customerId, initialValues?.id)
  const { t } = useTranslation('service-station')

  const onCreate = (form: any) => {
    createServiceStation(form, {
      onSuccess() {
        invalidateCustomersServiceStationDetails()
        invalidateCustomer.getCustomerUsersForAdmins(customerId, true)
        invalidateServiceStationCache.getAllTypeServiceStations(customerId)
        invalidateServiceStationCache.GetWithGroups(customerId)
        invalidateServiceStationCache.getServiceStationById(customerId, initialValues?.id)
        invalidateServiceStationCache.getServiceStationMinimalData(customerId)
        toast.success(t('service-station-added-successfully', { ns: 'service-station' }))
        pop()
      },
      onError() {
        toast.error(t('service-station-add-error', { ns: 'service-station' }))
      },
    })
  }

  const onEdit = (form: any) => {
    updateServiceStation(form, {
      onSuccess() {
        invalidateCustomersServiceStationDetails()
        invalidateCustomer.getCustomerUsersForAdmins(customerId, true)
        invalidateServiceStationCache.getAllTypeServiceStations(customerId)
        invalidateServiceStationCache.GetWithGroups(customerId)
        invalidateServiceStationCache.getServiceStationById(customerId, initialValues?.id)
        invalidateServiceStationCache.getServiceStationMinimalData(customerId)
        toast.success(t('service-station-updated-successfully', { ns: 'service-station' }))
        pop()
      },
      onError() {
        toast.error(t('service-station-update-error', { ns: 'service-station' }))
      },
    })
  }

  return (
    <ServiceStationFrom
      {...rest}
      initialValues={initialValues}
      customerId={customerId}
      title={title}
      pop={pop}
      onSubmit={initialValues?.id ? onEdit : onCreate}
    />
  )
}
